import React from "react";

import './overlay.styles.scss';

const Overlay = ({ images, visible, toggle }) => (
  <div className='overlay' onClick={toggle} style={{ display: !visible ? 'none' : null }}>
    <div className='overlay-container'>
      {images.map(image => 
        <div className='overlay-image-container' key={image.id}>
          <p className='overlay-title'>{image.title}</p>
          <img alt='Project' className='overlay-image center' src={image.image} />
        </div>
      )}
    </div>
  </div>
);

export default Overlay;
